import React from 'react'
import { Grid, TextField } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'

export const textoTipoPrisao = (valor) => {
  if (!valor) return ''
  if (valor === 'FLAGRANTE') return 'Flagrante'
  if (valor === 'MANDADO_PRISAO') return 'Cumprimento de mandado de Prisão'
  if (valor === 'NAO_INFORMADO') return 'Não informado : Detido conduzido pela policia penal'
  return ''
}

export const textoNaturezaSolicitacao = (valor) => {
  if (!valor) return ''
  if (valor === 'LESAO_CORPORAL_CULPOSA') return 'Lesão Corporal Culposa'
  if (valor === 'LESAO_CORPORAL_DOLOSA') return 'Lesão Corporal Dolosa'
  if (valor === 'VIAS_DE_FATO') return 'Vias de Fato'
  if (valor === 'AMEACA') return 'Ameaça'
  if (valor === 'INJURIA') return 'Injúria'
  if (valor === 'MARIA_DA_PENHA') return 'Maria da Penha'
  if (valor === 'PESSOA_COM_DEFICIENCIA') return 'Estatuto da Pessoa com Deficiência'
  if (valor === 'ECA') return 'ECA'
  if (valor === 'IDOSO') return 'Estatuto do Idoso'
  if (valor === 'TRANSITO') return 'Crime de Trânsito'
  if (valor === 'ESTUPRO_VULNERAVEL_I') return 'Estupro de Vulnerável I'
  if (valor === 'ESTUPRO_VULNERAVEL_II') return 'Estupro de Vulnerável II'
  if (valor === 'ESTUPRO_NAO_VULNERAVEL') return 'Estupro (não vulnerável)'
  if (valor === 'PROJETO_ABRACAR') return 'Projeto Abraçar'
  if (valor === 'OUTRO') return 'Outra natureza'
  return ''
}

export const textoCategoriaPrisao = (valor) => {
  if (!valor) return ''
  if (valor === 'LESAO_CORPORAL_CULPOSA') return 'Lesão Corporal Culposa'
  if (valor === 'LESAO_CORPORAL_DOLOSA') return 'Lesão Corporal Dolosa'
  if (valor === 'VIAS_DE_FATO') return 'Vias de Fato'
  if (valor === 'MARIA_DA_PENHA') return 'Crime tipificado na Maria da Penha'
  if (valor === 'ECA') return 'Crime tipificado no ECA'
  if (valor === 'ESTATUTO_IDOSO') return 'Crime Tipificado no Estatuto do Idoso'
  if (valor === 'PESSOA_DEFICIENCIA') return 'Crime Tipificado no Estatuto da Pessoa com Deficiência'
  if (valor === 'DIGNIDADE_SEXUAL') return 'Crime contra a dignidade sexual'
  if (valor === 'HONRA') return 'Crime contra a Honra'
  if (valor === 'RACISMO') return 'Crime de Racismo'
  if (valor === 'DOMESTICA') return 'Violência doméstica'
  if (valor === 'PSICOLOGICA') return 'Violência Psicológica'
  if (valor === 'DESOBEDIENCIA') return 'Desobediência'
  if (valor === 'DESACATO') return 'Desacato'
  if (valor === 'INJURIA') return 'Injúria'
  if (valor === 'CALUNIA') return 'Calúnia'
  if (valor === 'DIFAMACAO') return 'Difamação'
  if (valor === 'RECEPTACAO_SIMPLES') return 'Receptação simples'
  if (valor === 'RECEPTACAO_QUALIFICADA') return 'Receptação Qualificada'
  if (valor === 'CRIME_DE_DANO') return 'Crime de Dano'
  if (valor === 'ROUBO') return 'Roubo'
  if (valor === 'ROUBO_QUALIFICADO') return 'Roubo Qualificado'
  if (valor === 'LATROCINIO') return 'Latrocínio'
  if (valor === 'ASSOCIACAO_TRAFICO_DROGAS') return 'Associação para o tráfico de drogas'
  if (valor === 'ASSOCIACAO_CRIMINOSA') return 'Associação Criminosa'
  if (valor === 'ORGANIZACAO_CRIMINOSA') return 'Organização Criminosa'
  if (valor === 'FURTO') return 'Furto'
  if (valor === 'FURTO_QUALIFICADO') return 'Furto Qualificado'
  if (valor === 'FURTO_MEDIANTE_FRAUDE') return 'Furto Mediante Fraude'
  if (valor === 'ESTELIONATO') return 'Estelionato'
  if (valor === 'APROPRIACAO_INDEBITA') return 'Apropriação Indébita'
  if (valor === 'CORRUPCAO_ATIVA') return 'Corrupção Ativa'
  if (valor === 'CORRUPCAO_PASSIVA') return 'Corrupção Passiva'
  if (valor === 'PECULATO') return 'Peculato'
  if (valor === 'TRAFICO_DROGAS') return 'Tráfico de drogas'
  if (valor === 'HOMICIDIO_SIMPLES') return 'Homícidio Simples'
  if (valor === 'HOMICIDIO_QUALIFICADO') return 'Homícidio Qualificado'
  if (valor === 'FEMINICIDIO') return 'Feminicídio'
  if (valor === 'SEQUESTRO') return 'Sequestro'
  if (valor === 'CARCERE_PRIVADO') return 'Carcere Privado'
  if (valor === 'CRIME_DE_AMEACA') return 'Crime de Ameaça'
  if (valor === 'STALKING') return 'Stalking'
  if (valor === 'CRIME_DE_ESTUPRO') return 'Crime de Estupro'
  if (valor === 'VIOLENCIA_SEXUAL_MEDIANTE_FRAUDE') return 'Violência Sexual Mediante Fraude'
  if (valor === 'ASSEDIO_SEXUAL') return 'Assédio Sexual'
  if (valor === 'IMPORTUNACAO_SEXUAL') return 'Importunação Sexual'
  if (valor === 'FAVORECIMENTO_PROSTITUICAO') return 'Favorecimento a Prostituição'
  if (valor === 'ESTUPRO_VULNERAVEL') return 'Estupro de Vulnerável'
  if (valor === 'ATO_LIBIDINOSO') return 'Ato Libidinoso'
  if (valor === 'PATRIMONIO') return 'Crime contra o patrimônio'
  if (valor === 'TRANSITO') return 'Crime de Trânsito'
  if (valor === 'PORTE_ILEGAL_ARMA') return 'Porte ou uso ilegal de arma de fogo,acessário ou munição'
  if (valor === 'ADULTERACAO_IDENTIFICADOR_VEICULO') return 'Adulteração de sinal identificador de veículo automotor'
  if (valor === 'DIRECAO_ALCOOLICA') return 'Dirigir veículo automotor sob a influência de álcool ou outra substância psicoativa'
  if (valor === 'NAO_INFORMADO') return 'Não informado'
  if (valor === 'OUTRO') return 'Outro'
  return ''
}

const naturezaSolicitacaoOptions = [
  'LESAO_CORPORAL_CULPOSA',
  'LESAO_CORPORAL_DOLOSA',
  'VIAS_DE_FATO',
  'AMEACA',
  'INJURIA',
  'MARIA_DA_PENHA',
  'PESSOA_COM_DEFICIENCIA',
  'ECA',
  'IDOSO',
  'TRANSITO',
  'ESTUPRO_VULNERAVEL_I',
  'ESTUPRO_VULNERAVEL_II',
  'ESTUPRO_NAO_VULNERAVEL',
  'PROJETO_ABRACAR',
  'OUTRO',
]

const tipoPrisaoOptions = ['FLAGRANTE', 'MANDADO_PRISAO', 'NAO_INFORMADO']

const categoriaPrisaoOptions = [
  'LESAO_CORPORAL_CULPOSA',
  'LESAO_CORPORAL_DOLOSA',
  'VIAS_DE_FATO',
  'MARIA_DA_PENHA',
  'ECA',
  'ESTATUTO_IDOSO',
  'PESSOA_DEFICIENCIA',
  'DIGNIDADE_SEXUAL',
  'HONRA',
  'RACISMO',
  'DOMESTICA',
  'PSICOLOGICA',
  'DESOBEDIENCIA',
  'DESACATO',
  'INJURIA',
  'CALUNIA',
  'DIFAMACAO',
  'RECEPTACAO_SIMPLES',
  'RECEPTACAO_QUALIFICADA',
  'CRIME_DE_DANO',
  'ROUBO',
  'ROUBO_QUALIFICADO',
  'LATROCINIO',
  'ASSOCIACAO_TRAFICO_DROGAS',
  'ASSOCIACAO_CRIMINOSA',
  'ORGANIZACAO_CRIMINOSA',
  'FURTO',
  'FURTO_QUALIFICADO',
  'FURTO_MEDIANTE_FRAUDE',
  'ESTELIONATO',
  'APROPRIACAO_INDEBITA',
  'CORRUPCAO_ATIVA',
  'CORRUPCAO_PASSIVA',
  'PECULATO',
  'TRAFICO_DROGAS',
  'HOMICIDIO_SIMPLES',
  'HOMICIDIO_QUALIFICADO',
  'FEMINICIDIO',
  'SEQUESTRO',
  'CARCERE_PRIVADO',
  'CRIME_DE_AMEACA',
  'STALKING',
  'CRIME_DE_ESTUPRO',
  'VIOLENCIA_SEXUAL_MEDIANTE_FRAUDE',
  'ASSEDIO_SEXUAL',
  'IMPORTUNACAO_SEXUAL',
  'FAVORECIMENTO_PROSTITUICAO',
  'ESTUPRO_VULNERAVEL',
  'ATO_LIBIDINOSO',
  'PATRIMONIO',
  'TRANSITO',
  'PORTE_ILEGAL_ARMA',
  'ADULTERACAO_IDENTIFICADOR_VEICULO',
  'DIRECAO_ALCOOLICA',
  'NAO_INFORMADO',
  'OUTRO',
]

export const FormDadosQualificacao = (props) => {
  const {
    tipo,
    handleChangeTipoPericiando,
    naturezaSolicitacao,
    setNaturezaSolicitacao,
    tipoPrisao,
    setTipoPrisao,
    categoriaPrisao,
    setCategoriaPrisao,
    classes,
  } = props

  return (
    <Grid container spacing={2} className={classes.fieldGroup}>
      {/* Tipo do Periciando */}
      <Grid item xs={12}>
        <Autocomplete
          name="tipo"
          value={tipo}
          noOptionsText="Sem informações"
          options={['Menor infrator', 'Detido', 'Vítima']}
          onChange={(event, newValue) => handleChangeTipoPericiando(newValue)}
          getOptionSelected={(option, value) => option === value}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label="TIPO DO PERICIANDO"
              placeholder="Selecionar..."
              InputLabelProps={{
                shrink: true,
              }}
            />
          )}
        />
      </Grid>

      {/* Condicional para Vítima */}
      {tipo === 'Vítima' && (
        <Grid item md={6} sm={6} xs={12}>
          <Autocomplete
            name="naturezaSolicitacao"
            value={naturezaSolicitacao}
            multiple
            noOptionsText="Sem informações"
            options={naturezaSolicitacaoOptions}
            getOptionSelected={(option, value) => option === value}
            onChange={(event, newValue) => setNaturezaSolicitacao(newValue)}
            getOptionLabel={(option) => textoNaturezaSolicitacao(option)}
            renderOption={(option) => textoNaturezaSolicitacao(option)}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label="NATUREZA DA SOLICITAÇÃO"
                placeholder="Selecionar..."
                InputLabelProps={{
                  shrink: true,
                }}
              />
            )}
          />
        </Grid>
      )}

      {/* Condicional para Menor Infrator ou Detido */}
      {(tipo === 'Menor infrator' || tipo === 'Detido') && (
        <>
          <Grid item md={6} sm={6} xs={12}>
            <Autocomplete
              name="tipoPrisao"
              value={tipoPrisao}
              multiple
              noOptionsText="Sem informações"
              options={tipoPrisaoOptions}
              getOptionSelected={(option, value) => option === value}
              onChange={(event, newValue) => setTipoPrisao(newValue)}
              getOptionLabel={(option) => textoTipoPrisao(option)}
              renderOption={(option) => textoTipoPrisao(option)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  label="TIPO DE PRISÃO"
                  placeholder="Selecionar..."
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              )}
            />
          </Grid>

          <Grid item md={6} sm={6} xs={12}>
            <Autocomplete
              name="categoriaPrisao"
              value={categoriaPrisao}
              noOptionsText="Sem informações"
              multiple
              options={categoriaPrisaoOptions}
              getOptionSelected={(option, value) => option === value}
              onChange={(event, newValue) => setCategoriaPrisao(newValue)}
              getOptionLabel={(option) => textoCategoriaPrisao(option)}
              renderOption={(option) => textoCategoriaPrisao(option)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  label="CATEGORIA DA PRISÃO"
                  placeholder="Selecionar..."
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              )}
            />
          </Grid>
        </>
      )}
    </Grid>
  )
}
